import { render, staticRenderFns } from "./AppSignupFormSection.vue?vue&type=template&id=4fa4485c&scoped=true"
import script from "./AppSignupFormSection.vue?vue&type=script&lang=ts"
export * from "./AppSignupFormSection.vue?vue&type=script&lang=ts"
import style0 from "./AppSignupFormSection.vue?vue&type=style&index=0&id=4fa4485c&prod&lang=scss&scoped=true"
import style1 from "./AppSignupFormSection.vue?vue&type=style&index=1&id=4fa4485c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4485c",
  null
  
)

export default component.exports